import type { JSX } from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { SetPageStateValue } from 'src/shared/pageState';

import {
	StarterDashboardV2BreakpointStateProvider,
	useStarterDashboardV2PageNotificationManagerContext,
} from 'src/app/pages/starterDashboardV2/pageContext';

import { PageBodyReskin } from '../components/PageBody/index_new';
import { PageHeader } from '../components/PageHeader';

import { usePageStateValue } from './hooks/usePageStateValue';

export function LayoutReskin(): JSX.Element {
	/*
	Tracking page view is disabled to avoid double tracking during reskin experiment. The tracking is done in the
	original/control component. We would need to uncomment this when the reskin replaces the original component.
	 */
	// useTrackPageView();
	const { petition } = usePageStateValue();
	const {
		data: { notification },
	} = useStarterDashboardV2PageNotificationManagerContext();

	// We depend on client breakpoints
	return (
		<>
			<SetPageStateValue name="petition" value={petition} />
			<ClientRender placeholder={<div className="h-16" />}>
				<StarterDashboardV2BreakpointStateProvider>
					<PageHeader />
					<div className="bg-fill-inverse-strong h-full w-full">
						{notification?.content}
						<PageBodyReskin />
					</div>
				</StarterDashboardV2BreakpointStateProvider>
			</ClientRender>
		</>
	);
}
